export const STANDARD_RATES_CODE = 'StandardRates';
export const SPECIAL_RATES_CODE = 'Special';
export const P17_CODE = 'P17';
export const MRW_CODE = 'MRW';
export const EEO_MEMBER_CODES = ['E0P', 'E0S', 'E0G'];
export const STRIKE_PRICE_THRESHOLD_PERCENTAGE = 3.3;
